import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {api, clearSession, getCookie, parseJwtPayload, setCookie} from '../api';

export default function TenantSelector() {
  const navigate = useNavigate();
  const [tenants, setTenants] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    api('/tenants').then(r => r.json()).then(data => {
      if (data.length === 1) {
        const token = getCookie('renewalToken');
        const payload = token ? parseJwtPayload(token) : null;
        const expires = payload?.exp ? new Date(payload.exp * 1000) : null;
        setCookie('tenantId', data[0].id, expires);
        setCookie('tenantName', encodeURIComponent(data[0].name), expires);
        navigate(redirect || '/apps', {replace: true});
      } else {
        setTenants(data);
      }
    }).catch(() => {});
    api('/me').then(r => r.ok ? r.json() : {}).then(u => setIsAdmin(!!u.admin)).catch(() => {});
  }, []);

  const params = new URLSearchParams(window.location.search);
  const redirect = params.get('redirect');

  const getRenewalExpiry = () => {
    const token = getCookie('renewalToken');
    const payload = token ? parseJwtPayload(token) : null;
    return payload?.exp ? new Date(payload.exp * 1000) : null;
  };

  const select = (tenant) => {
    const expires = getRenewalExpiry();
    setCookie('tenantId', tenant.id, expires);
    setCookie('tenantName', encodeURIComponent(tenant.name), expires);
    navigate(redirect || '/apps');
  };

  const currentTenantId = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('tenantId='))?.split('=')[1];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-20">
          <img src="/images/matterking-logo.png" alt="Matter King" className="h-16 w-auto" />
          <div className="flex items-center gap-4">
            <a href="/settings" className="text-gray-600 hover:text-gray-900 font-medium text-sm">Settings</a>
            <button onClick={() => {
              clearSession();
              navigate('/login');
            }} className="text-gray-600 hover:text-red-600 font-medium text-sm">Sign Out</button>
          </div>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">Select an Organization</h1>
        <div className="space-y-3">
          {tenants.map(t => (
            <button key={t.id} onClick={() => select(t)}
              className={`w-full text-left p-5 bg-white rounded-lg shadow hover:shadow-lg transition border-2 ${t.id === currentTenantId ? 'border-red-600' : 'border-transparent hover:border-red-600'}`}>
              <h2 className="text-lg font-semibold text-gray-900">{t.name}</h2>
              <p className="text-sm text-gray-500 mt-1">Created {new Date(t.createdAt).toLocaleDateString()}</p>
            </button>
          ))}
          {tenants.length === 0 && (
            <p className="text-center text-gray-500">No organizations found. Ask an admin to create one.</p>
          )}
        </div>
      </main>
    </div>
  );
}
